/* istanbul ignore file */
import { useQuery } from 'urql';
import { graphql } from '@packages/gql/generated/shopping';
import { useMemo } from 'react';
import { useIntl } from 'react-intl';

const BreadcrumbDocument = graphql(/* GraphQL */ `
  query BreadcrumbBasketData($categoryId: ID!, $locale: String!) {
    breadcrumb(category: $categoryId, locale: $locale) {
      breadCrumb {
        name
      }
    }
  }
`);

// on detailview breadcrumb data comes instant from cache
export const useBreadcrumbs = (categoryId?: string) => {
  const { locale } = useIntl();
  const [{ data }] = useQuery({
    query: BreadcrumbDocument,
    variables: { categoryId: categoryId ?? '', locale: locale! },
    context: useMemo(() => ({ suspense: false }), []),
    pause: !categoryId,
  });
  if (!categoryId) return undefined;
  const { breadcrumb } = { ...data };
  return breadcrumb?.breadCrumb?.map((entry) => entry.name) || [];
};
